module.exports = __webpack_public_path__ + "assets/img/first_user_s.11b6fc30.svg";